import { ErrorBoundary } from './lib/ErrorBoundary';
import { GreetingCard } from './components/greeting';
import { TopicInput } from './components/topic-input';
import { CompletionMessage, ContentReview, WorkflowVisualization } from './components/workflow-stage';
import "./App.css"
import { WorkflowProvider } from './context/workflowProvider';


const WorkflowApp: React.FC = () => {
  return (
    <ErrorBoundary>
      <WorkflowProvider>
        <div className="min-h-screen bg-gray-100">
          <div className="container mx-auto px-4 py-8 max-w-4xl">
            <div className="text-center mb-8">
              <h1 className="text-4xl font-bold text-gray-900 mb-2">The AntKit.</h1>
              <p className="text-gray-600">Brought to you by <span className='font-special text-xl'>ECHELON AI</span></p>
            </div>

            <GreetingCard />
            <TopicInput />
            <WorkflowVisualization />
            <ContentReview />
            <CompletionMessage />
          </div>
        </div>
      </WorkflowProvider>
    </ErrorBoundary>
  );
};

export default WorkflowApp;